export default {
  container: {
    position: 'relative',
    minHeight: '100vh',
    width: '100vw',
  },
  page: {
    width: '100%',
    height: '100vh',
  },
}
